import React, { lazy, Suspense } from "react";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { CookieSetting } from "cookiesetting-component";

import LOPage from './components/Loinfo/Loinfo';
import ErrorPage from './components/error/ErrorPage';
import CacheBuster from "react-cache-buster";
import appversion from "../package.json";
import useLOData from "./components/Utils/useLOData";
import { useParams } from 'react-router-dom';


const Home = lazy(() => import("./Home"));
function App() {
  const { loName } = useParams();
  const { agentName } = useParams();

  // console.log(loName,agentName, "imadadul")

  const isProduction = process.env.NODE_ENV === "production";
 const newData = useLOData(agentName)
//  console.log(newData)
  
  return (
    <CacheBuster
    currentVersion={appversion.version}
    isEnabled={isProduction} //If false, the library is disabled.
    isVerboseMode={false} //If true, the library writes verbose logs to console.
    // loadingComponent={<Loading />} //If not pass, nothing appears at the time of new version check.
    metaFileDirectory={"."} //If public assets are hosted somewhere other than root on your server.
  >
    <>
    <Router>
      <Routes>
        <Route path="/homeownership-program" element={<Home />} />
        <Route exact path="/homeownership-program/:agentName" element={<LOPage />} />
        {/* <Route exact path="*" element={<ErrorPage />}  /> */}
        {/* <Route exact path="/:agentName" element={<AgentHome />} /> */}
      </Routes>
    </Router>
    <CookieSetting 
        privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK} 
        configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
        analytics={process.env.REACT_APP_ANALYTICS_PATH}
      />
  </> 
    </CacheBuster>
  );
}

export default App;
